import { createApp } from 'vue'
import { createVfm, ModalsContainer } from 'vue-final-modal'
import VueDOMPurifyHTML from 'vue-dompurify-html'

import '../styles/entry.scss'
// eslint-disable-next-line import/no-unresolved
import 'vue-final-modal/style.css'

import 'picturefill'
import 'lazysizes'
import 'babel-polyfill'
import 'element-closest-polyfill'
import './plain'
import './tagging'
import './utils/jsapi-youku'
import './utils/onetrust-renew'
import './plugins/ls.unveilhooks'
import './plugins/lazysizes-bgset'
import './utils/lazysizes-bg-init'

import VueSocialSharing from 'vue-social-sharing'
import Hotjar from '@hotjar/browser'
import VueMasonry from 'vue-masonry-css'
import VueScrollTo from 'vue-scrollto'
import genericSlider from './plain/generic-slider'
import slider from './plain/slider'

// Import store Vuex
import store from './store'

import ions from './components/ions'
import atoms from './components/atoms'
import molecules from './components/molecules'
import organisms from './components/organisms'

import vacuum from './components/vacuum'

// Import directives
import * as directives from './directives'

// Import sitecore vue plugin
// import KeySiteCore from './sitecore/KeySiteCore'

import SitecoreVueAdapter from './plugins/sc-vue-adapter-plugin/sc-vue-adapter'
import SitecoreExpEditorPlugin from './plugins/sc-vue-adapter-plugin/vue-sc-plugin'

const initApp = () => {
  // Hotjar
  const siteId = import.meta.env.VITE_SITE_ID
  const hotjarVersion = 6
  Hotjar.init(siteId, hotjarVersion)

  const app = createApp({})
  const vfm = createVfm()

  const componentList = [...ions, ...atoms, ...molecules, ...organisms, ...vacuum]

  componentList.forEach((component) => {
    app.component(component.name, component)
  })

  Object.entries(directives).forEach(([name, directive]) => {
    app.directive(name, directive)
  })

  // Initialize the sitecore vue plugin

  app.use(SitecoreExpEditorPlugin)
  // Initialize the other plugins
  app.use(VueScrollTo)
  app.use(VueMasonry)
  app.use(store)
  app.use(vfm)
  app.use(VueSocialSharing)
  app.component('modalscontainer', ModalsContainer)
  app.use(VueDOMPurifyHTML)

  slider()
  genericSlider()

  // Vue mount
  app.mount('#vue-container')
}

SitecoreVueAdapter.InitialiseVueApp(initApp)
